module.exports = __webpack_public_path__ + "img/invoice-ch-female-banner.0924495b.png";